class DepartmentDetail {
    constructor(item) {
        // Переменные
        this.element = item;
        this.placeholder = this.element.querySelector('.js-video-placeholder');

        // Функции
        this.setListeners();
    };

    setListeners() {
        this.placeholder.addEventListener('click', () => {
            this.placeholder.classList.add('is-hide');

        }, {once: true});
    }
};

document.querySelectorAll('.js-departments-detail').forEach((item) => new DepartmentDetail(item));
